var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0303 3.96967C14.3232 4.26256 14.3232 4.73744 14.0303 5.03033L7.03033 12.0303C6.73744 12.3232 6.26256 12.3232 5.96967 12.0303L2.46967 8.53033C2.17678 8.23744 2.17678 7.76256 2.46967 7.46967C2.76256 7.17678 3.23744 7.17678 3.53033 7.46967L6.5 10.4393L12.9697 3.96967C13.2626 3.67678 13.7374 3.67678 14.0303 3.96967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.271e8678168aef26c916367d38faff74.svg";
export { ForwardRef as ReactComponent };